import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Stack,
    Typography,
    IconButton,
    Box,
} from "@mui/material";
import { MODAL_TYPE } from "../../constants/common";
import { BASE_IMG_URL } from "../../constants/mainAPI";
import Loader from "../../components/Loader/Loader";
import { useParallelRequests } from "./utils/useParallelRequests";
import { useParams } from "react-router-dom";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { getDateTimeFormat } from "../../utils/getDateFormat";
import { useEffect, useState } from "react";
import { DocumentData } from "../../types/api/documents";
import CustomSnackbar from "../../components/UI/CustomSnackbar";
import Modal from "../../components/UI/Modal/Modal";
import { useNotification } from "../../hooks/useNotification";
import { SubmitHandler } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";
import { deleteDocument } from "../../api/documentAPI";
import { UploadButtonForm } from "../../components/forms/ReportForm/ui/UploadButtonForm";
import { labelMapper, TextMapper } from "./types/documentTypes";
import { DocumentTable } from "../../components/UI/DocumentTable/DocumentTable";

export const DocumentsPage = () => {
    const { id } = useParams();

    const { loading, setLoading, data, refreshData, error } = useParallelRequests(String(id));

    const isOwner =
        localStorage.getItem("employee_type") == "16" &&
        localStorage.getItem("employee_center_id") == localStorage.getItem("current_center_id");

    const [deleteDocumentId, setDeleteDocumentId] = useState(0);

    const { setNotification, setOpenSnackbar, notification, openSnackbar } = useNotification();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [currentModalType, setCurrentModalType] = useState("edit");
    const closeModal = () => {
        setShowModal(false);
    };

    const del: SubmitHandler<any> = () => {
        setLoading(true);
        deleteDocument(
            id,
            deleteDocumentId,
            () => {
                refreshData();
                setNotification({
                    severity: "success",
                    message: "Данные о документе удалены успешно",
                });
                setOpenSnackbar(true);
                setLoading(false);
            },
            err => {
                setNotification({
                    severity: "error",
                    message: err.message || "",
                });
                setOpenSnackbar(true);
                setLoading(false);
            },
        );
        closeModal();
    };

    const deleteContent = <div>Вы уверены, что хотите удалить данные о документе?</div>;

    const modalType = {
        [MODAL_TYPE.delete]: {
            title: "Удаление данных о документе",
            onSubmit: del,
            content: deleteContent,
        },
    };

    useEffect(() => {
        if (error) {
            setNotification({
                severity: "error",
                message: (error as any)?.message || "",
            });
            setOpenSnackbar(true);
        }
    }, [error]);

    return (
        <div className={"container"}>
            <div className={"pageHeader"}>Документы центра</div>
            <Box sx={{ marginBottom: "80px" }}>
                <Stack gap={2}>
                    {Object.entries(data).map(([key, value]: [string, DocumentData[]]) => (
                        <DocumentTable
                            key={key}
                            documents={value}
                            title={labelMapper[key as TextMapper]}
                            onDeleteChange={id => {
                                setShowModal(true);
                                setDeleteDocumentId(id);
                                setCurrentModalType(MODAL_TYPE.delete);
                            }}
                        />
                    ))}
                </Stack>
            </Box>
            <div className={"posBR"}>
                {isOwner && (
                    <UploadButtonForm
                        onChange={val => {
                            setTimeout(() => {
                                if (val) {
                                    refreshData();
                                }
                            }, 300);
                        }}
                        showTagSelector
                        isDocTagsOnly
                    />
                )}
            </div>
            <Modal
                open={showModal}
                title={modalType[currentModalType]?.title}
                onClose={() => {
                    closeModal();
                }}
                onSubmit={modalType[currentModalType]?.onSubmit}>
                {modalType[currentModalType]?.content}
            </Modal>
            <CustomSnackbar openSnackbar={openSnackbar} setOpenSnackbar={setOpenSnackbar} notification={notification} />
            <Loader backDrop open={loading} />
        </div>
    );
};
